import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const BadgeDotIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 8"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <g id="Badge Dot" clipPath="url(#clip0_833_13802)">
        <circle id="Dot" cx={4} cy={4} r={4} fill={color}></circle>
      </g>

    </svg>
  );
};

export default BadgeDotIcon;
